import { extend, configure, localize } from 'vee-validate';
import { required, email, min, max, confirmed, numeric, alpha, alpha_num } from 'vee-validate/dist/rules';
import pt_BR from 'vee-validate/dist/locale/pt_BR.json';

configure({
  defaultMessage: (field, values) => {
    values._field_ = field;
    return pt_BR.messages[values._rule_];
  }
});

extend('required', {
  ...required,
  message: 'O campo {_field_} é obrigatório'
});

extend('email', {
  ...email,
  message: 'O campo {_field_} deve ser um email válido'
});

extend('min', {
  ...min,
  message: 'O campo {_field_} deve ter pelo menos {length} caracteres'
});

extend('max', {
  ...max,
  message: 'O campo {_field_} deve ter no máximo {length} caracteres'
});

extend('confirmed', {
  ...confirmed,
  message: 'A confirmação do campo {_field_} não confere'
});

extend('numeric', {
  ...numeric,
  message: 'O campo {_field_} deve conter apenas números'
});

extend('alpha', {
  ...alpha,
  message: 'O campo {_field_} deve conter apenas letras'
});

extend('alpha_num', {
  ...alpha_num,
  message: 'O campo {_field_} deve conter apenas letras e números'
});


localize('pt_BR', pt_BR);
